// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import Vue from "vue";
import "select2";
import "select2/dist/css/select2.css";
import VueFilter from "vue-filter";
import App from "./App";
import moment from "moment";
import router from "./router";
import Moment from "vue-moment";
import vModal from "vue-js-modal";
import Vuelidate from "vuelidate";
import vMask from "v-mask";
import Swal from "vue-sweetalert2";
import VTooltip from "v-tooltip";
import VuexStore from "./storevuex";
import CPClipboard from "vue-clipboard2";
import VueCarousel from "vue-carousel"

// import './firebase'
// import asset css
import "sweetalert2/dist/sweetalert2.min.css";

Vue.config.productionTip = false;

Vue.use(VueCarousel);
Vue.use(VueFilter);
Vue.use(Moment);
Vue.use(vMask);
Vue.use(vModal, { dynamic: true, dialog: true });
Vue.use(Vuelidate);
Vue.use(Swal);
Vue.use(VTooltip);
Vue.use(CPClipboard);
Vue.use(require("v-suggest").default);

/*
==============================================
VUE-CUSTOM-DIRECTIVE
==============================================
*/
let handleOutsideClick;

Vue.prototype.$toEmoji = function(value) {
  return value
    .replace(/\\u(....)/g, (match, p1) => String.fromCharCode(parseInt(p1, 16)))
    .replace(/\\(\d{3})/g, (match, p1) => String.fromCharCode(parseInt(p1, 8)));
};
Vue.directive("closeable", {
  bind(el, binding, vnode) {
    handleOutsideClick = e => {
      e.stopPropagation();
      const { exclude, handler } = binding.value;
      let clickedOnExecludeEl = false;
      exclude.forEach(refName => {
        if (!clickedOnExecludeEl) {
          const excludeElement = vnode.context.$refs[refName];
          clickedOnExecludeEl = excludeElement.contains(e.target);
        }
      });
      if (!el.contains(e.target) && !clickedOnExecludeEl) {
        vnode.context[handler]();
      }
    };

    document.addEventListener("click", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);
  },
  unbind() {
    document.removeEventListener("click", handleOutsideClick);
    document.removeEventListener("touchstart", handleOutsideClick);
  }
});

Vue.filter("reverse", function(value) {
  return value.slice().reverse();
});

Vue.filter("LimitString", function(value, limit) {
  if (!value) return "";
  return value.length > limit ? value.substring(0, limit) + "..." : value;
});

Vue.filter("FTime", function(value) {
  if (!value) return "";
  return moment("2020-12-01 " + value).format("hh:mm A");
});

Vue.filter("ImojiDecode", function(value) {
  if (value != null) {
    return value
      .replace(/\\u(....)/g, (match, p1) =>
        String.fromCharCode(parseInt(p1, 16))
      )
      .replace(/\\(\d{3})/g, (match, p1) =>
        String.fromCharCode(parseInt(p1, 8))
      );
  }
});
// window.addEventListener('load', function () {
//   console.log('======== ONLOAD VUE JS TO PREPARE  ===== ')
//   if ('serviceWorker' in navigator) {
//     navigator.serviceWorker.register('../firebase-messaging-sw.js').then(function (register) {
//       console.log('registration service worker is success')
//       console.log(register.scope)
//     },
//     function (err) {
//       console.log('error registration ===== with ' + err)
//     })
//   }
// })

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store: VuexStore,
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js